module.exports = {
	"getting-started": [
		[
			"article",
			"Facts About Municipal Bonds",
			"https://www.msrb.org/sites/default/files/Facts-About-Municipal-Bonds.pdf"
		],
		[
			"tv",
			"What is an Official Statement?",
			"https://www.msrb.org/media/view/76948"
		],
		[
			"tv",
			"What's Inside an Official Statement?",
			"https://www.msrb.org/media/view/76949"
		],
		[
			"tv",
			"What is Financial Disclosure?",
			"https://www.msrb.org/media/view/76956"
		],
		[
			"article",
			"Using EMMA® to Monitor Your Bonds",
			"https://www.msrb.org/sites/default/files/Monitoring-Bonds.pdf"
		],
		[
			"article",
			"Tax and Liquidity Considerations for Discount Bonds",
			"https://www.msrb.org/sites/default/files/Tax-and-Liquidity-Considerations-for-Buying-Discount-Bonds.pdf"
		]
	],
	"the-municipal-market": [
		[
			"article",
			"Municipal Market 101",
			"https://www.msrb.org/sites/default/files/Municipal-Market-101-Online.pdf"
		],
		[
			"tv",
			"The Municipal Bond Market and the MSRB",
			"https://www.msrb.org/media/view/76964"
		],
		[
			"article",
			"Muni Facts",
			"https://www.msrb.org/sites/default/files/2022-09/MSRB-Muni-Facts.pdf"
		],
		[
			"campaign",
			"Getting the Facts on the Muni Market",
			"https://www.msrb.org/media/view/234"
		],
		[
			"books",
			"Glossary of Municipal Securities Terms",
			"https://www.msrb.org/sites/default/files/2022-08/MSRB-Glossary-of-Municipal-Securities-Terms-Third_Edition-August-2013.pdf"
		],
		[
			"books",
			"Original Issue Discount Bonds",
			"https://www.msrb.org/sites/default/files/Original-Issue-Discount-Bonds.pdf"
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/municipals/education.json
// module id = 1830
// module chunks = 0